import signingAxios from './signingAxiosService';

const BASE = 'public/signing';

export class SigningService {
    constructor(token) {
        this._authHeader = token ? { Authorization: `Bearer ${token}` } : {};
    }

    getEmailHint = (signerProcessId) =>
        signingAxios.get(`${BASE}/${signerProcessId}/email-hint`);

    requestOtp = (signerProcessId) =>
        signingAxios.post(`${BASE}/${signerProcessId}/request-otp`);

    verifyOtp = (signerProcessId, code) =>
        signingAxios.post(`${BASE}/${signerProcessId}/verify-otp`, { code });

    getSigningInfo = (signerProcessId) =>
        signingAxios.get(`${BASE}/${signerProcessId}`, { headers: this._authHeader });

    initiateSign = (signerProcessId) =>
        signingAxios.post(`${BASE}/${signerProcessId}/sign`, {}, { headers: this._authHeader });

    cancelSigning = (signerProcessId) =>
        signingAxios.delete(`${BASE}/${signerProcessId}`, { headers: this._authHeader });
}
